import React from "react";
import { func } from "prop-types";
import {
  FormGroup,
  FormControl,
  FormLabel,
  Button,
  Form,
} from "react-bootstrap";

export class PartnersLoginForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      emailAddress: "",
      resetPasswordFormValidated: false,
    };
  }

  /* ----------- Validation Method ------------ */
  updateResetPasswordFormValidation = (resetPasswordFormValidated) => {
    this.setState({ resetPasswordFormValidated });
  };

  /* ----------- Event Handlers ------------- */
  handleInput = (event) => {
    const field = event.target.id;
    const { value } = event.target;

    this.setState({ [field]: value });
  };

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
      const form = e.currentTarget;
      if (form.checkValidity() === false) {
        e.stopPropagation();
        this.updateResetPasswordFormValidation(true);
      } else {
        const formData = {
          emailAddress: this.state.emailAddress,
        };
        this.props.onPartnersForgotPassword(formData);
        this.props.showLoginForm();
      }
    }
  };

  handleResetPasswordKeyPress = (event) => {
    if (event.charCode === 13) {
      this.handleSubmit();
    }
  };

  render() {
    // style variables
    const linkButtonStyle = {
      color: "#193783",
      textDecoration: "underline",
      backgroundColor: "none",
      border: "0",
      textAlign: "center",
      margin: 0,
      padding: 0,
    };

    return (
      <>
        <h1
          style={{
            fontSize: "28px",
            lineHeight: "1.5",
            marginBottom: "16px",
          }}
          className="mt-0"
        >
          Criteria Partner Login
        </h1>
        <p className="mb-5" style={{ fontSize: "16px" }}>
          Enter your email address below to receive an email containing a link
          to reset your password.
        </p>
        <Form
          noValidate
          validated={this.state.resetPasswordFormValidated}
          onSubmit={this.handleSubmit}
        >
          <FormGroup>
            <FormLabel className="mb-1">
              <strong>Email Address</strong>
            </FormLabel>
            <FormControl
              type="email"
              placeholder="Type your email here"
              id="emailAddress"
              value={this.state.emailAddress}
              onChange={this.handleInput}
              onKeyPress={this.handleResetPasswordKeyPress}
              data-test="email"
              style={{ borderColor: "#b1b3b3" }}
              required
            />
            <Form.Control.Feedback type="invalid">
              Enter your email here
            </Form.Control.Feedback>
          </FormGroup>
          <div className="text-center">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              id="resetPassword"
              className="mt-3 mb-3"
              style={{ backgroundColor: "#425cc7", width: "100%" }}
              disabled={this.state.emailAddress === ""}
            >
              Reset password
            </Button>
            <br />
          </div>
        </Form>
        <div className="text-center">
          <button
            type="button"
            style={linkButtonStyle}
            onClick={this.props.showLoginForm}
            id="backToLogin"
          >
            Back to log in
          </button>
        </div>
      </>
    );
  }
}

PartnersLoginForm.propTypes = {
  showLoginForm: func.isRequired,
  onPartnersForgotPassword: func.isRequired,
};

export default PartnersLoginForm;
